import { createFileRoute, redirect } from '@tanstack/react-router';

import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/sourcing/demand-groups')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/projects/$projectId/sourcing/overview/$view',
            params: {
                projectId: params.projectId,
                view: 'demand-groups',
            },
            replace: true,
        });
    },
});
